<div class="d-flex flex-column">
  <span>{{ label }}</span>
  <input
    class="color-picker"
    formControlName="Color"
    [style.background]="color"
    [style.width]="'auto'"
    [cpPosition]="position"
    [cpDisableInput]="isInputHidden"
    [cpOutputFormat]="outputFormat"
    [cpOKButton]="true"
    [cpOKButtonClass]="'btn btn-primary btn-xs'"
    [cpSaveClickOutside]="false"
    [cpPresetColors]="presetColors"
    [disabled]="isDisabled"
    [(colorPicker)]="color"
    (colorPickerSelect)="colorChange.emit($event)"
  />
</div>
